export const SET_CONTACT_INFO = 'SET_CONTACT_INFO';
export const UPDATE_CONTACT_DETAILS_DONE = 'UPDATE_CONTACT_DETAILS_DONE';
export const UPDATE_CONTACT_DETAILS_INIT = 'UPDATE_CONTACT_DETAILS_INIT';
export const UPDATE_CONTACT_DETAILS_FAILED = 'UPDATE_CONTACT_DETAILS_FAILED';
export const GET_PAYMENT_HISTORY_INIT = 'GET_PAYMENT_HISTORY_INIT';
export const GET_PAYMENT_HISTORY_DONE = 'GET_PAYMENT_HISTORY_DONE';
export const GET_PAYMENT_HISTORY_FAILED = 'GET_PAYMENT_HISTORY_FAILED';
export const SET_PLAN_UPGRADE = 'SET_PLAN_UPGRADE';
export const UNSET_PLAN_UPGRADE = 'UNSET_PLAN_UPGRADE';
export const GET_FEATURES_INIT = 'GET_FEATURES_INIT';
export const GET_FEATURES_DONE = 'GET_FEATURES_DONE';
export const GET_FEATURES_FAILED = 'GET_FEATURES_FAILED';
export const SET_FEATURES_INIT = 'SET_FEATURES_INIT';
export const SET_FEATURES_DONE = 'SET_FEATURES_DONE';
export const SET_FEATURES_FAILED = 'SET_FEATURES_FAILED';
export const GET_BILLING_ADDRESS_DONE = 'GET_BILLING_ADDRESS_DONE';
export const GET_BILLING_ADDRESS_INIT = 'GET_BILLING_ADDRESS_INIT';
export const GET_BILLING_ADDRESS_FAILED = 'GET_BILLING_ADDRESS_FAILED';
export const GET_EXPORT_STATUS_INIT = 'GET_EXPORT_STATUS_INIT';
export const GET_EXPORT_STATUS_DONE = 'GET_EXPORT_STATUS_DONE';
export const GET_EXPORT_STATUS_FAILED = 'GET_EXPORT_STATUS_FAILED';
export const ACCOUNT_DELETE_REASON_INIT = 'ACCOUNT_DELETE_REASON_INIT';
export const ACCOUNT_DELETE_REASON_FAILED = 'ACCOUNT_DELETE_REASON_FAILED';
export const ACCOUNT_DELETE_REASON_DONE = 'ACCOUNT_DELETE_REASON_DONE';
export const ACCOUNT_DELETE_INIT = 'ACCOUNT_DELETE_INIT';
export const ACCOUNT_DELETE_FAILED = 'ACCOUNT_DELETE_FAILED';
export const ACCOUNT_DELETE_DONE = 'ACCOUNT_DELETE_DONE';
export const SAVE_USER_DETAILS = 'SAVE_USER_DETAILS';
export const INITIATE_EXPORT_INIT = 'INITIATE_EXPORT_INIT';
export const INITIATE_EXPORT_DONE = 'INITIATE_EXPORT_DONE';
export const INITIATE_EXPORT_FAILED = 'INITIATE_EXPORT_FAILED';
export const GET_ACCOUNT_DETAILS_INIT = 'GET_ACCOUNT_DETAILS_INIT';
export const GET_ACCOUNT_DETAILS_DONE = 'GET_ACCOUNT_DETAILS_DONE';
export const GET_ACCOUNT_DETAILS_FAILED = 'GET_ACCOUNT_DETAILS_FAILED';
export const GET_UPGRADE_PLANS_INIT = 'GET_UPGRADE_PLANS_INIT';
export const GET_UPGRADE_PLANS_FAILED = 'GET_UPGRADE_PLANS_FAILED';
export const GET_UPGRADE_PLANS_DONE = 'GET_UPGRADE_PLANS_DONE';
export const GET_MP_UPGRADE_PLANS_FAILED = 'GET_MP_UPGRADE_PLANS_FAILED';
export const GET_MP_UPGRADE_PLANS_DONE = 'GET_MP_UPGRADE_PLANS_DONE';
export const GET_BILL_AMOUNT_INIT = 'GET_BILL_AMOUNT_INIT';
export const GET_BILL_AMOUNT_DONE = 'GET_BILL_AMOUNT_DONE';
export const GET_BILL_AMOUNT_FAILED = 'GET_BILL_AMOUNT_FAILED';
export const PLAN_UPGRADE_INIT = 'PLAN_UPGRADE_INIT';
export const PLAN_UPGRADE_DONE = 'PLAN_UPGRADE_DONE';
export const PLAN_UPGRADE_FAILED = 'PLAN_UPGRADE_FAILED';
export const STRIPE_CARD_DETAILS_INIT = 'STRIPE_CARD_DETAILS_INIT';
export const STRIPE_CARD_DETAILS_DONE = 'STRIPE_CARD_DETAILS_DONE';
export const STRIPE_CARD_DETAILS_FAILED = 'STRIPE_CARD_DETAILS_FAILED';
export const GET_INVOICE_DETAIL_INIT = 'GET_INVOICE_DETAIL_INIT';
export const GET_INVOICE_DETAIL_DONE = 'GET_INVOICE_DETAIL_DONE';
export const GET_INVOICE_DETAIL_FAILED = 'GET_INVOICE_DETAIL_FAILED';
export const TEMPLATE_LOAD = 'TEMPLATE_LOAD';
export const TEMPLATE_INIT_LOAD = 'TEMPLATE_INIT_LOAD';
export const GET_BUSINESS_HOUR_TEMPLATES = 'GET_BUSINESS_HOUR_TEMPLATES';
export const UPDATE_BUSINESS_HOUR_TEMPLATE_DONE ='UPDATE_BUSINESS_HOUR_TEMPLATE_DONE';
export const GET_BUSINESS_HOUR_TEMPLATE_DATA = 'GET_BUSINESS_HOUR_TEMPLATE_DATA';
export const  PAYMENT_INIT = 'PAYMENT_INIT';
export const  PAYMENT_DONE = 'PAYMENT_DONE';
export const  PAYMENT_FAILED = 'PAYMENT_FAILED';
export const  RESET_PAYMENT_ERROR = 'RESET_PAYMENT_ERROR';
export const  RESET_CARD_CHANGE_ERROR = 'RESET_CARD_CHANGE_ERROR';
export const RESET_INVOICE_PAYMENT_ERROR = 'RESET_INVOICE_PAYMENT_ERROR';
export const PLAN_UPGRADE_QUALIFIES = 'PLAN_UPGRADE_QUALIFIES'
export const PLAN_UPGRADE_QUALIFIES_DONE = 'PLAN_UPGRADE_QUALIFIES_DONE'
export const PLAN_UPGRADE_QUALIFIES_FAILED = 'PLAN_UPGRADE_QUALIFIES_FAILED';
export const STRIPE_SCA_REQUIRED = 'STRIPE_SCA_REQUIRED';
export const CLEAR_STRIPE_SCA = "CLEAR_STRIPE_SCA";
export const GET_BILLING_CONTACTS_DETAILS_DONE = "GET_BILLING_CONTACTS_DETAILS_DONE";
export const SET_BILLING_CONTACT_INFO = 'SET_BILLING_CONTACT_INFO';
export const UPDATE_BILLING_CONTACT_DETAILS_DONE = 'UPDATE_BILLING_CONTACT_DETAILS_DONE';
export const UPDATE_BILLING_CONTACT_DETAILS_INIT = 'UPDATE_BILLING_CONTACT_DETAILS_INIT';
export const UPDATE_BILLING_CONTACT_DETAILS_FAILED = 'UPDATE_BILLING_CONTACT_DETAILS_FAILED';
export const GET_BILLING_CONTACT_DETAILS_DONE = "GET_BILLING_CONTACT_DETAILS_DONE";
export const GET_BILLING_CONTACT_DETAILS_INIT = "GET_BILLING_CONTACT_DETAILS_INIT";
export const GET_BILLING_CONTACT_DETAILS_FAILED = "GET_BILLING_CONTACT_DETAILS_FAILED";
export const PUBLIC_PERMALINK = "public-permalinks";
export const FETCH_COUNTRY_LIST = 'FETCH_COUNTRY_LIST';
export const FETCH_COUNTRY_STATES = 'FETCH_COUNTRY_STATES';
export const FETCH_ZIP_CODE_DATA = 'FETCH_ZIP_CODE_DATA';
export const GET_CONTACT_DETAILS_INIT = 'GET_CONTACT_DETAILS_INIT';
export const GET_CONTACT_DETAILS_DONE = 'GET_CONTACT_DETAILS_DONE';
export const GET_CONTACT_DETAILS_FAILED = 'GET_CONTACT_DETAILS_FAILED';
export const SET_FOOTER_TEXT = 'SET_FOOTER_TEXT';
export const SET_OOO_SETTINGS = 'SET_OOO_SETTINGS';